import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { HtmlTemplatesService } from '../../services/html-templates.service';
import { UrlConstants } from '../../../shared/utils/url-constants';
import { AppConfigService } from '../../services/app-config.service';
import packageInfo from '../../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: []
})
export class FooterComponent implements OnInit {
  UrlConstants = UrlConstants;
  AppConfigService = AppConfigService;
  appVersion = packageInfo.version;

  constructor(
    public authService: AuthService,
    public htmlTemplatesService: HtmlTemplatesService
  ) {}

  ngOnInit(): void {}

  onNavigateToUserGuide(): void {
    if (this.authService.isLoggedIn()) {
      this.htmlTemplatesService.getUserGuideUrl().subscribe(url => {
        window.open(url, '_blank');
      });
    }
  }

  onNavigateToPolicy(): void {
    if (this.authService.isLoggedIn()) {
      this.htmlTemplatesService.getPolicyUrl().subscribe(url => {
        window.open(url, '_blank');
      });
    }
  }

  onNavigateToTermofUse(): void {
    if (this.authService.isLoggedIn()) {
      this.htmlTemplatesService.getTermUrl().subscribe(url => {
        window.open(url, '_blank');
      });
    }
  }
}
